export enum EStudyMethods {
  'Child' = 'getChildContent',
  'Student' = 'getStudentContent',
}
